const sfLa = [
  {
    languages:'es-mx',
    text:'México - Español',
  },
  {
    languages:'en-us',
    text:'United States - English',
  },
  {
    languages:'es-us',
    text:'Estados Unidos - Español',
  },
  {
    languages:'es-ar',
    text:'Argentina - Español',
  },
  {
    languages:'pt-br',
    text:'Brasil - Português',
  },
  {
    languages:'en-ca',
    text:'Canada - English',
  },
  {
    languages:'fr-ca',
    text:'Canada - Français',
  },
  {
    languages:'es-cl',
    text:'Chile - Español',
  },
  {
    languages:'cn-cn',
    text:'China - Mandarin',
  },
  {
    languages:'es-co',
    text:'Colombia - Español',
  },
  {
    languages:'es-cr',
    text:'Costa Rica - Español',
  },
  {
    languages:'es-ec',
    text:'Ecuador - Español',
  },
  {
    languages:'es-sv',
    text:'El Salvador - Español',
  },
  {
    languages:'es-es',
    text:'España - Español',
  },
  {
    languages:'en-eu',
    text:'Europe - English',
  },
  {
    languages:'fr-fr',
    text:'France - Français',
  },
  {
    languages:'en-gb',
    text:'Great Britain - English',
  },
  {
    languages:'es-gt',
    text:'Guatemala - Español',
  },
  {
    languages:'es-hn',
    text:'Honduras - Español',
  },
  {
    languages:'jp-jp',
    text:'Japan - Nihongo',
  },
  {
    languages:'en-nl',
    text:'Netherlands - English',
  },
  {
    languages:'es-ni',
    text:'Nicaragua - Español',
  },
  {
    languages:'es-pa',
    text:'Panamá  - Español',
  },
  {
    languages:'es-pe',
    text:'Perú - Español',
  },
  {
    languages:'es-do',
    text:'Rep. Dominicana - Español',
  },
  {
    languages:'en-kr',
    text:'South Korea - Korean',
  }];

export default sfLa;
